import { render, staticRenderFns } from "./FormControlTypeEmail.vue?vue&type=template&id=2b69adb1&scoped=true"
import script from "./FormControlTypeEmail.vue?vue&type=script&lang=js"
export * from "./FormControlTypeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b69adb1",
  null
  
)

export default component.exports